import { render, staticRenderFns } from "./swiper2.vue?vue&type=template&id=41213a36&scoped=true&"
import script from "./swiper2.vue?vue&type=script&lang=js&"
export * from "./swiper2.vue?vue&type=script&lang=js&"
import style0 from "./swiper2.vue?vue&type=style&index=0&id=41213a36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41213a36",
  null
  
)

export default component.exports